import { useLocation } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { usePermissions } from '@contexts/PermissionsContext';
import { useLanguage } from '@contexts/LanguageContext';

/**
 * A one-line ribbon on any page whose menu was granted as "Lihat saja".
 *
 * Without it a read-only user meets the restriction only as a failed action:
 * the API refuses the write and a toast explains it after the fact. Saying so
 * up front is the difference between a rule and a bug.
 */
export default function ReadOnlyNotice() {
  const { pathname } = useLocation();
  const { accessLevel } = usePermissions();
  const { t } = useLanguage();

  if (accessLevel(pathname) !== 'read') return null;

  const [before, after = ''] = t('lumen.frame.readOnlyNotice').split('{bold}');

  return (
    <div className="flex items-center gap-2 border-line border-b bg-raised px-4 py-2 text-fg-muted text-xs">
      <Eye aria-hidden className="size-[15px] shrink-0" />
      <p>
        {before}
        <b className="font-semibold text-fg">{t('lumen.frame.readOnlyBold')}</b>
        {after}
      </p>
    </div>
  );
}

export { ReadOnlyNotice };
